import React, { useRef, useState } from "react";
import "../../css_files/Reports/Reports.css";
import GenerateReport from "./GenerateReport";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance, { getCookie } from "../../api";
import { jwtDecode } from "jwt-decode";

function Reports() {
  const [salesData, setSalesData] = useState([]);
  const [ticketsData, setTicketsData] = useState([]);
  const reportRef = useRef([]);
  const [emailloading, setEmailloading] = useState(false);
  const [technicalData, setTechnicalData] = useState([]);
  const [outstandingData, setOutstandingData] = useState([]);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return (
    <section className="reports">
      <GenerateReport
        setSalesData={setSalesData}
        setTicketsData={setTicketsData}
        setTechnicalData={setTechnicalData}
        setOutstandingData={setOutstandingData}
      />
      {salesData.length > 0 && (
        <>
          <blockquote className="generated-reports-actions">
            {emailloading ? (
              <i class="fa-solid fa-arrows-spin fa-spin"></i>
            ) : (
              <i
                className="fa-solid fa-envelope"
                onClick={() => {
                  setEmailloading(true);
                  html2canvas(reportRef.current[0]).then((canvas) => {
                    axiosInstance
                      .post(
                        `${process.env.REACT_APP_API_URL}/api/SendEmail/SendMail`,
                        {
                          To: jwtDecode(getCookie("token"))?.email,
                          Base64String: canvas.toDataURL("image/png"),
                        }
                      )
                      .then((res) => {
                        toast.success(res.data, {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      })
                      .catch((err) => {
                        toast.error("Failed to Send Mail", {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      });
                  });
                }}
              ></i>
            )}
            <i
              className="fa-solid fa-print"
              title="Print"
              onClick={() => window.print()}
            ></i>
            <i
              className="fa-solid fa-download"
              title="Download"
              onClick={() => {
                html2canvas(reportRef.current[0]).then((canvas) => {
                  const imgData = canvas.toDataURL("image/png");
                  const pdf = new jsPDF("p", "mm", "a4");

                  const pdfWidth = pdf.internal.pageSize.getWidth();
                  const pdfHeight = pdf.internal.pageSize.getHeight();

                  const bottomPadding = 10;
                  const usableHeight = pdfHeight - bottomPadding;

                  const imgWidth = pdfWidth;
                  const imgHeight = (canvas.height * imgWidth) / canvas.width;

                  let heightLeft = imgHeight;
                  let position = 0;

                  pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                  );
                  heightLeft -= usableHeight;

                  while (heightLeft > 0) {
                    position -= usableHeight;
                    pdf.addPage();
                    pdf.addImage(
                      imgData,
                      "PNG",
                      0,
                      position,
                      imgWidth,
                      imgHeight
                    );
                    heightLeft -= usableHeight;
                  }
                  const now = new Date()
                    .toISOString()
                    .replace(/[:.-]/g, "")
                    .replace("T", "_")
                    .slice(0, 15);

                  pdf.save(`SalesReport_${now}.pdf`);
                });
              }}
            ></i>
          </blockquote>
          <div ref={(el) => (reportRef.current[0] = el)}>
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Quotation Id</th>
                  <th>Year</th>
                  <th>Month</th>
                  <th>TotalAmountToPay</th>
                  <th>AmountPaid</th>
                  <th>Enquiry Type</th>
                </tr>
              </thead>
              <tbody>
                {salesData.map((x, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{x.quotationId}</td>
                    <td>{x.year}</td>
                    <td>{months[x.month - 1]}</td>
                    <td>
                      {x.symbol} {Math.round(x.totalAmountToPay)}
                    </td>
                    <td>
                      {x.symbol} {x.amountPaid}
                    </td>
                    <td>{x.enquiryType}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {ticketsData.length > 0 && (
        <>
          <blockquote className="generated-reports-actions">
            {emailloading ? (
              <i class="fa-solid fa-arrows-spin fa-spin"></i>
            ) : (
              <i
                className="fa-solid fa-envelope"
                onClick={() => {
                  setEmailloading(true);
                  html2canvas(reportRef.current[1]).then((canvas) => {
                    axiosInstance
                      .post(
                        `${process.env.REACT_APP_API_URL}/api/SendEmail/SendMail`,
                        {
                          To: jwtDecode(getCookie("token"))?.email,
                          Base64String: canvas.toDataURL("image/png"),
                        }
                      )
                      .then((res) => {
                        toast.success(res.data, {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      })
                      .catch((err) => {
                        toast.error("Failed to Send Mail", {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      });
                  });
                }}
              ></i>
            )}
            <i className="fa-solid fa-print" title="Print"></i>
            <i
              className="fa-solid fa-download"
              title="Download"
              onClick={() => {
                html2canvas(reportRef.current[1]).then((canvas) => {
                  const imgData = canvas.toDataURL("image/png");
                  const pdf = new jsPDF("p", "mm", "a4");

                  const pdfWidth = pdf.internal.pageSize.getWidth();
                  const pdfHeight = pdf.internal.pageSize.getHeight();

                  const bottomPadding = 10;
                  const usableHeight = pdfHeight - bottomPadding;

                  const imgWidth = pdfWidth;
                  const imgHeight = (canvas.height * imgWidth) / canvas.width;

                  let heightLeft = imgHeight;
                  let position = 0;

                  pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                  );
                  heightLeft -= usableHeight;

                  while (heightLeft > 0) {
                    position -= usableHeight;
                    pdf.addPage();
                    pdf.addImage(
                      imgData,
                      "PNG",
                      0,
                      position,
                      imgWidth,
                      imgHeight
                    );
                    heightLeft -= usableHeight;
                  }
                  const now = new Date()
                    .toISOString()
                    .replace(/[:.-]/g, "")
                    .replace("T", "_")
                    .slice(0, 15);
                  pdf.save(`Tickets_Report_${now}.pdf`);
                });
              }}
            ></i>
          </blockquote>
          <div ref={(el) => (reportRef.current[1] = el)}>
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Ticket Id</th>
                  <th>Enquiry Type</th>
                  <th>Quotation Sent</th>
                  <th>Order Created</th>
                  <th>Status</th>
                  <th>Service Type</th>
                  <th>Linked to Enquiry Id</th>
                  <th>Operation Type</th>
                  <th>Due Date</th>
                  <th>Service Description</th>
                </tr>
              </thead>
              <tbody>
                {ticketsData.map((ticket, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{ticket.seriesId}</td>
                    <td>{ticket.enquiryType}</td>
                    <td>{ticket.isQuotationSent ? "Yes" : "No"}</td>
                    <td>{ticket.isOrderCreated ? "Yes" : "No"}</td>
                    <td>{ticket.status}</td>
                    <td>{ticket.serviceDetails.serviceType}</td>
                    <td>{ticket.enquirySeriesId}</td>
                    <td>{ticket.serviceDetails.operationType}</td>
                    <td>
                      {new Date(ticket.serviceDetails.dueDate).toDateString()}
                    </td>
                    <td>{ticket.serviceDetails.serviceDescription}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {technicalData.length > 0 && (
        <>
          <blockquote className="generated-reports-actions">
            {emailloading ? (
              <i class="fa-solid fa-arrows-spin fa-spin"></i>
            ) : (
              <i
                className="fa-solid fa-envelope"
                onClick={() => {
                  setEmailloading(true);
                  html2canvas(reportRef.current[2]).then((canvas) => {
                    axiosInstance
                      .post(
                        `${process.env.REACT_APP_API_URL}/api/SendEmail/SendMail`,
                        {
                          To: jwtDecode(getCookie("token"))?.email,
                          Base64String: canvas.toDataURL("image/png"),
                        }
                      )
                      .then((res) => {
                        toast.success(res.data, {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      })
                      .catch((err) => {
                        toast.error("Failed to Send Mail", {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      });
                  });
                }}
              ></i>
            )}
            <i className="fa-solid fa-print" title="Print"></i>
            <i
              className="fa-solid fa-download"
              title="Download"
              onClick={() => {
                html2canvas(reportRef.current[2]).then((canvas) => {
                  const imgData = canvas.toDataURL("image/png");
                  const pdf = new jsPDF("p", "mm", "a4");

                  const pdfWidth = pdf.internal.pageSize.getWidth();
                  const pdfHeight = pdf.internal.pageSize.getHeight();

                  const bottomPadding = 10;
                  const usableHeight = pdfHeight - bottomPadding;

                  const imgWidth = pdfWidth;
                  const imgHeight = (canvas.height * imgWidth) / canvas.width;

                  let heightLeft = imgHeight;
                  let position = 0;

                  pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                  );
                  heightLeft -= usableHeight;

                  while (heightLeft > 0) {
                    position -= usableHeight;
                    pdf.addPage();
                    pdf.addImage(
                      imgData,
                      "PNG",
                      0,
                      position,
                      imgWidth,
                      imgHeight
                    );
                    heightLeft -= usableHeight;
                  }
                  const now = new Date()
                    .toISOString()
                    .replace(/[:.-]/g, "")
                    .replace("T", "_")
                    .slice(0, 15);
                  pdf.save(`Technical_Report_${now}.pdf`);
                });
              }}
            ></i>
          </blockquote>
          <div ref={(el) => (reportRef.current[2] = el)}>
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Username</th>
                  <th>Role</th>
                  <th>Ticket Assigned</th>
                  <th>Deal Status</th>
                  <th>Due Date Passed</th>
                </tr>
              </thead>
              <tbody>
                {technicalData.map((technical, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{technical.username}</td>
                    <td>{technical.user.role}</td>
                    <td>{technical.ticketId}</td>
                    <td>{technical.ticket.status}</td>
                    <td>
                      {new Date() >
                      new Date(technical.ticket.serviceDetails.dueDate)
                        ? "Yes"
                        : "No"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
      {outstandingData.length > 0 && (
        <>
          <blockquote className="generated-reports-actions">
            {emailloading ? (
              <i class="fa-solid fa-arrows-spin fa-spin"></i>
            ) : (
              <i
                className="fa-solid fa-envelope"
                onClick={() => {
                  setEmailloading(true);
                  html2canvas(reportRef.current[3]).then((canvas) => {
                    axiosInstance
                      .post(
                        `${process.env.REACT_APP_API_URL}/api/SendEmail/SendMail`,
                        {
                          To: jwtDecode(getCookie("token"))?.email,
                          Base64String: canvas.toDataURL("image/png"),
                        }
                      )
                      .then((res) => {
                        toast.success(res.data, {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      })
                      .catch((err) => {
                        toast.error("Failed to Send Mail", {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setEmailloading(false);
                      });
                  });
                }}
              ></i>
            )}
            <i className="fa-solid fa-print" title="Print"></i>
            <i
              className="fa-solid fa-download"
              title="Download"
              onClick={() => {
                html2canvas(reportRef.current[3]).then((canvas) => {
                  const imgData = canvas.toDataURL("image/png");
                  const pdf = new jsPDF("p", "mm", "a4");

                  const pdfWidth = pdf.internal.pageSize.getWidth();
                  const pdfHeight = pdf.internal.pageSize.getHeight();

                  const bottomPadding = 10;
                  const usableHeight = pdfHeight - bottomPadding;

                  const imgWidth = pdfWidth;
                  const imgHeight = (canvas.height * imgWidth) / canvas.width;

                  let heightLeft = imgHeight;
                  let position = 0;

                  pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                  );
                  heightLeft -= usableHeight;

                  while (heightLeft > 0) {
                    position -= usableHeight;
                    pdf.addPage();
                    pdf.addImage(
                      imgData,
                      "PNG",
                      0,
                      position,
                      imgWidth,
                      imgHeight
                    );
                    heightLeft -= usableHeight;
                  }
                  const now = new Date()
                    .toISOString()
                    .replace(/[:.-]/g, "")
                    .replace("T", "_")
                    .slice(0, 15);
                  pdf.save(`Outstanding_Report_${now}.pdf`);
                });
              }}
            ></i>
          </blockquote>
          <div ref={(el) => (reportRef.current[3] = el)}>
            <table>
              <thead>
                <tr>
                  <th>Sr.No.</th>
                  <th>Quotation Id</th>
                  <th>Type</th>
                  <th>Final Total</th>
                  <th>GST Amount</th>
                  <th>Discount Amount</th>
                  <th>Total Amount to Pay</th>
                  <th>Outstanding Amount</th>
                </tr>
              </thead>
              <tbody>
                {outstandingData.map((x, i) => (
                  <tr>
                    <td>{i + 1}</td>
                    <td>{x.quotationId}</td>
                    <td>{x.enquiryType}</td>
                    <td>
                      {x.symbol} {x.finalTotal}
                    </td>
                    <td>
                      {x.symbol} {x.gstAmount}
                    </td>
                    <td>
                      {x.symbol} {x.discountAmount}
                    </td>
                    <td>
                      {x.symbol} {Math.round(x.totalAmountToPay)}
                    </td>
                    <td>
                      {x.symbol} {Math.round(x.totalAmountToPay) - x.amountPaid}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </section>
  );
}

export default Reports;
